import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideDanger } from '../../../redux/actions/snackbarActions';
import { Snackbar, SnackbarContent, IconButton, Icon, Typography } from '@material-ui/core';
import { instajobTheme } from '../../helpers/instajobTheme';

class DangerSnackbar extends Component {
    render() {
        const { message, show, hideDanger } = this.props;
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={show}
                autoHideDuration={6000}
                onClose={hideDanger}>
                <SnackbarContent
                    aria-describedby="client-snackbar"
                    style={{ backgroundColor: instajobTheme.palette.error.main }}
                    message={
                        <Typography variant="body1" style={{ padding: 0 }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Icon style={{marginRight: 15}}>close</Icon>
                                {message}
                            </div>
                        </Typography>
                    }
                    action={[
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={hideDanger}>
                            <Icon>close</Icon>
                        </IconButton>
                    ]}
                />
            </Snackbar>
        );
    }
}

const mapDangerActionsToProps = dispatch => (
    bindActionCreators({ hideDanger }, dispatch)
);

const mapDangerStateToProps = store => ({
    message: store.snackbarState.message.danger,
    show: store.snackbarState.show.danger
});

// const mapDefaultStateToProps = store => ({
//     message: store.snackbarState.message.default,
//     show: store.snackbarState.show.default
// });

export default connect(mapDangerStateToProps, mapDangerActionsToProps)(DangerSnackbar);